export const COMMON_LOADER_DEFAULT_DELAY_TIMEOUT = 300;
